import { useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchRatingAccessorialsList } from '../data-provider/rates/api';

export const useRatingAccessorialsList = (searchFilter?: string) => {
  const queryClient = useQueryClient();

  const queryKeyBase = ['quote-rating-accessorials'];

  const query = useQuery({
    enabled: Boolean(searchFilter && searchFilter.length > 0),
    queryFn: () => fetchRatingAccessorialsList(searchFilter || ''),
    queryKey: [...queryKeyBase, searchFilter],
  });

  const asyncFunction = async (params?: Record<string, unknown>) => {
    const search = String(params?.SearchValue || '');
    const key = [...queryKeyBase, search];

    const data = await queryClient.query({
      queryFn: () => fetchRatingAccessorialsList(search),
      queryKey: key,
    });

    return { data };
  };

  return {
    ...query,
    asyncFunction,
  };
};
